import { render, staticRenderFns } from "./Successpayment.vue?vue&type=template&id=3befb73f&scoped=true&"
import script from "./Successpayment.vue?vue&type=script&lang=js&"
export * from "./Successpayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3befb73f",
  null
  
)

export default component.exports